"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("../../lib");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ArcInput(props) {
  var className = props.className,
    id = props.id,
    disabled = props.disabled,
    onPressEnter = props.onPressEnter,
    type = props.type,
    value = props.value,
    placeholder = props.placeholder,
    onChange = props.onChange,
    status = props.status,
    showCount = props.showCount,
    allowClear = props.allowClear,
    defaultValue = props.defaultValue,
    onBlur = props.onBlur,
    onKeyUp = props.onKeyUp,
    readonly = props.readonly,
    required = props.required;
  return /*#__PURE__*/_react["default"].createElement(_lib.Input, _extends({}, props, {
    style: {
      width: '100%'
    },
    type: type ? type : 'text',
    readOnly: readonly,
    required: required
  }));
}
var _default = ArcInput;
exports["default"] = _default;